/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import AnalysisMenu from '@/components/analysis/AnalysisMenu'
import NavBar from '@/components/shared/NavBar'

import {Component, Vue} from 'vue-property-decorator'
import {AnalysisVO} from '@/valueObjects/AnalysisVO'
import {AnalysisService} from '@/services/AnalysisService'
import AnalysisServiceMixin from '@/services/AnalysisServiceMixin'
import AnalysisHeader from '@/components/analysis/AnalysisHeader'
import MessageBox from '@/components/shared/MessageBox'
import {sleep} from '@/utils/Timer'

@Component({
    components: {
        AnalysisMenu,
        NavBar,
        AnalysisHeader,
        MessageBox,
    },
    mixins: [AnalysisServiceMixin],
})

export default class Analysis extends Vue {
    private analysis: AnalysisVO = null
    private isFinished: boolean = false
    private message: string = ''
    private analysisService: AnalysisService
    private destroyed = false
    private showHeader = true

    public async mounted() {
        this.refreshAnalysis()
    }

    private async pollAnalysisUntilFinished(analysisId: number): Promise<void> {
        try {
            while (true) {
                [this.analysis, this.isFinished] = await this.analysisService.getAnalysis(analysisId)
                if(this.isFinished) {
                    return
                }
                await sleep()
            }
            
        } catch (e) {
            this.showErrorMessage(e.errorMessage)
        }
    }

    private reloadAnalysisList(): void {
        this.$router.push({name: 'analysislist'})
    }

    private showErrorMessage(errorMessage: string): void {
        this.message = errorMessage
        this.$router.push({name: 'analysis-error'})
    }

    private beforeDestroy() {
        this.destroyed = true
    }

    private displayHeader(showHeader: boolean) {
        this.showHeader = showHeader
    }

    private async refreshAnalysis() {
        if (this.$route.params.analysisId !== undefined) {
            await this.pollAnalysisUntilFinished(Number(this.$route.params.analysisId))
        }
    }
}
